import './Toast.scss';
import { connect } from 'react-redux';
import { green, red, yellow } from 'theme/theme.constant';
import store from 'Store';
import { addToast } from '../../config/Redux/global.reducer';
// const TOAST_TIMEOUT = 3000;

const Container = (props) => {
	const renderToast = () => {
		return (
			<div className="Toast">
				<div className="Content">
					<div className="Title">{props.toast.title}</div>
					<div className="Message">{props.toast.message}</div>
				</div>
				{/* <div className="Control">
					<i className="fas fa-times"></i>
				</div> */}
				<div className="Progress" style={{ background: props.toast.color }}></div>
			</div>
		);
	};
	return <>{props.toast ? renderToast() : null}</>;
};

const showToast = (data) => {
	store.dispatch(addToast(data)); // Update Redux state
	setTimeout(() => store.dispatch(addToast(null)), 5000); // Auto-hide after 5s
};

export const Toaster = {
	success: (data) => {
		data.color = green[900];
		showToast(data);
	},
	warning: (data) => {
		data.color = yellow[900];
		showToast(data);
	},
	info: (data) => {
		data.color = yellow[900];
		showToast(data);
	},
	error: (data) => {
		data.color = red[900];
		showToast(data);
	},
};

const MapPropsToState = (state) => {
	return {
		toast: state.toast,
	};
};

export const ToastContainer = connect(MapPropsToState)(Container);
